export const environment = {
  production: false,
  BaseURL: 'https://kridapi.devservices.uk/api/',
  ApiUrl: 'https://kridapi.devservices.uk/api/',
  AiApiUrl: 'https://kioskdemoadmin.shaligraminfotech.com/api/',
  isUnderMaintance: false,
  DocumentBaseUrl: 'https://kridapi.devservices.uk/',
  CurrencyFormat: 'GB',
  CurrencySymbol: '£',
  siteKey: '6LdolzIqAAAAANNJqmw9j55O-jfCWlPv8KU75TSf'
};
